
import React, { useEffect, useRef, useState, useCallback } from "react";
import {
  Box,
  Typography,
  TextField,
  IconButton,
  CircularProgress
} from "@mui/material";
import { ArrowUpOutlined, DownOutlined } from "@ant-design/icons";
import { UserApiService, MessageAPIService } from "../../services/api";
import { useWebSocket } from "../../shared/ws";
import Log from "../../shared/logger";
import "./ChatPage.css";
import { useLocation } from "react-router-dom";
import { LinearProgress } from "@mui/material";
import ProductPage from "../UI_Recommendations/ProductPage";
import ShoppingList from "../Shopping_list/ShoppingList";
import ShoppingListV2 from "../Shopping_list/ShoppingListV2";
import LogoIcon from "../../assests/Images/kangaroo.webp";

const ChatPage = ({ isDesktop, link,tester }) => {
  const phoneRef = useRef(null);
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const initialMsg = query.get("msg");
  const dummy_phone = query.get("phone");
  const [lastProgressStepIndex, setLastProgressStepIndex] = useState(-1);
  const [userPhoneNumber, setUserPhoneNumber] = useState("");
  const [isSubmittingPhone, setIsSubmittingPhone] = useState(false);
  const alreadyUsedMsg = sessionStorage.getItem("usedMsg");
  const userMsg = !alreadyUsedMsg && initialMsg ? initialMsg : null;
  const [testFlag, setTestFlag] = useState(false);
  const [trackingPhone, setTrackingPhone] = useState(dummy_phone || phoneRef.current);
  const [preLoadedData,setPreLoadedData] = useState(false);


  // NEW: Track message sources and prevent duplicates
  const messageSourcesRef = useRef(new Map()); // messageId -> 'api' | 'websocket' | 'both'
  const pendingMessagesRef = useRef(new Map()); // messageId -> full message object
  const shownTextMessagesRef = useRef(new Set()); // Track body text already shown

  const [messageRenderKey, setMessageRenderKey] = useState(0); // Force re-render when needed

  useEffect(() => {
    setTestFlag(true);
  }, [dummy_phone]);

  useEffect(() => {
    if (initialMsg && !alreadyUsedMsg) {
      sessionStorage.setItem("usedMsg", "true");
    }
  }, [initialMsg, alreadyUsedMsg]);

  if (!phoneRef.current) {
    const randomNum = Math.floor(1000000000 + Math.random() * 9000000000);
    phoneRef.current = "+91" + randomNum;
  }

  const phone = dummy_phone || phoneRef.current;
  const conversationRef = useRef(null);
  const loaderRef = useRef(null);
  const inputRef = useRef(null);
  const [showTyping, setShowTyping] = useState(false);

  const [productDataMap, setProductDataMap] = useState({});
  const [messages, setMessages] = useState([]);
  const [threadId, setThreadId] = useState("");
  const [customMessage, setCustomMessage] = useState(userMsg || "");
  const [loading, setLoading] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [maxPage, setMaxPage] = useState(1);
  const [loadedPages, setLoadedPages] = useState(new Set());
  const [noMoreOldMessages, setNoMoreOldMessages] = useState(false);
  const [showScrollDown, setShowScrollDown] = useState(false);

  const [progress, setProgress] = useState(0);
  const [progressMsg, setProgressMsg] = useState("");
  const [progressActive, setProgressActive] = useState(false);
  const progressRef = useRef(null);
  const progressTextRef = useRef(null);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [productId, setProductId] = useState("");
  const [index, setIndex] = useState(0);
  const [showLoading, setShowLoading] = useState(false);

  const pendingProductIdRef = useRef(null);

  // NEW: Unified message handler to prevent race conditions
  const handleIncomingMessage = useCallback((msg, source = 'websocket') => {
    console.log(`📨 Message from ${source}:`, msg);

    // Special handling for product_search messages (they don't have IDs initially)
    if (msg?.product_search === 'true' || msg?.product_search === 'partial_results') {
      console.log('🔍 Product search message detected, processing without ID check');
      processMessage(msg, source);
      return;
    }

    const messageId = msg?.id;
    if (!messageId) {
      console.warn('Message without ID received:', msg);
      // Process anyway for backward compatibility
      processMessage(msg, source);
      return;
    }

    // Track message source for regular messages
    const existingSource = messageSourcesRef.current.get(messageId);
    if (existingSource) {
      console.log(`🔄 Duplicate message ${messageId} from ${source}, already received from ${existingSource}`);
      // Update source tracking but don't add duplicate
      messageSourcesRef.current.set(messageId, 'both');
      return;
    }

    messageSourcesRef.current.set(messageId, source);
    pendingMessagesRef.current.set(messageId, msg);

    // Process the message
    processMessage(msg, source);
  }, []);

  const processMessage = useCallback((msg, source) => {
    if (msg?.tracking_phone) {
      setTrackingPhone(msg.tracking_phone);
    }

    if (msg?.product_search === 'true') {
      handleProductSearchStart(msg);
    } else if (msg?.product_search === "partial_results") {
      handlePartialResults(msg);
    } else if(msg?.product_search === "completed"){
      handlePreDataLoading(msg)
    } else {
      handleRegularMessage(msg, source);
    }
  }, []);

  const handleProductSearchStart = useCallback((msg) => {
    console.log("🔍 Product search started");

    // Show the initial message body if it exists
    if (msg?.body) {
      const textMessage = {
        id: `search-text-${Date.now()}-${Math.random()}`,
        body: msg.body,
        source: 'assistant',
        received_at: new Date().toISOString(),
        type: 'text_only' // Mark as text-only to prevent ProductPage rendering
      };
      // addMessageIfNotExist(textMessage);
    }

    let progressSteps = getProgressSteps(msg);

    startProgress(progressSteps);
    setShowTyping(false);

    const partialData = [
      { "asin": "", "image": "", "key": "", "link": "", "price": "", "rating": "", "reviews": "", "store": "", "title": "" },
      { "asin": "", "image": "", "key": "", "link": "", "price": "", "rating": "", "reviews": "", "store": "", "title": "" },
      { "asin": "", "image": "", "key": "", "link": "", "price": "", "rating": "", "reviews": "", "store": "", "title": "" },
    ];

    const productPlaceholderId = `product-${Date.now()}-${Math.random()}`;
    pendingProductIdRef.current = productPlaceholderId;
    console.log("📦 Created product placeholder:", productPlaceholderId);

    setProductDataMap(prev => ({
      ...prev,
      [productPlaceholderId]: { data: partialData, loading: true, keyword: "", is_list: msg?.is_list }
    }));

    const placeholderMsg = {
      id: productPlaceholderId,
      type: 'product_loading',
      source: 'assistant',
      received_at: new Date().toISOString()
    };

    // Add placeholder message with proper tracking
    setMessages(prev => {
      const exists = prev.some(m => m.id === placeholderMsg.id);
      if (exists) return prev;
      return [...prev, placeholderMsg];
    });

    // requestAnimationFrame(() => scrollToBottom());
  }, []);

  const handlePreDataLoading = useCallback((msg)=>{
    const receivedMsg = msg?.response_data;

    console.log("responseData",receivedMsg)
    // setProductId(receivedMsg?.search_id)
    const hasPendingProduct = pendingProductIdRef.current !== null;

    if (receivedMsg?.shopping_page_url) {
      const { url, phone: extractedPhone, id } = extractPhoneAndId(receivedMsg.shopping_page_url, receivedMsg?.is_list);
      link(url);

      const productId = pendingProductIdRef.current;

      console.log("✅ Final data received. Pending product:", productId, "Has pending:", hasPendingProduct);

      if (extractedPhone && id && productId && hasPendingProduct) {
        console.log("🔄 Updating existing product placeholder with final data");

        // Store the full body in productDataMap for rendering with the product
        setProductDataMap(prev => ({
          ...prev,
          [productId]: {
            ...prev[productId],
            phone: extractedPhone,
            productId: id,
            loading: false,
            keyword: receivedMsg?.keyword,
            is_list: receivedMsg?.is_list,
            body: ""
          }
        }));

        setMessages(prev => prev.map(m =>
        m?.id === productId ? { ...m, type: 'product' } : m
      ));
        setPreLoadedData(true);

        // pendingProductIdRef.current = null;

        setShowTyping(false);
        stopProgress();

        return;
      }
    }

  })

  const handlePartialResults = useCallback((msg) => {
    console.log("📊 Received partial results");
    const responseData = msg?.response_data;
    const partialData = [
      {
        "asin": responseData?.top_rated_product?.asin,
        "image": responseData?.top_rated_product?.image,
        "key": responseData?.top_rated_product?.key,
        "link": responseData?.top_rated_product?.link,
        "price": responseData?.top_rated_product?.price,
        "rating": responseData?.top_rated_product?.rating,
        "reviews": responseData?.top_rated_product?.reviews,
        "store": responseData?.top_rated_product?.store,
        "title": responseData?.top_rated_product?.title
      },
      {
        "asin": responseData?.lowest_priced_product?.asin,
        "image": responseData?.lowest_priced_product?.image,
        "key": responseData?.lowest_priced_product?.key,
        "link": responseData?.lowest_priced_product?.link,
        "price": responseData?.lowest_priced_product?.price,
        "rating": responseData?.lowest_priced_product?.rating,
        "reviews": responseData?.lowest_priced_product?.reviews,
        "store": responseData?.lowest_priced_product?.store,
        "title": responseData?.lowest_priced_product?.title
      },
      { "asin": "", "image": "", "key": "", "link": "", "price": "", "rating": "", "reviews": "", "store": "", "title": "" },
    ];

    const productId = pendingProductIdRef.current;
    console.log("🔄 Updating product with partial data:", productId);

    if (productId) {
      setProductDataMap(prev => ({
        ...prev,
        [productId]: {
          ...prev[productId],
          data: partialData,
          loading: true,
          keyword: msg?.keyword,
          is_list: msg?.is_list
        }
      }));

      setMessages(prev => prev.map(m =>
        m?.id === productId ? { ...m, type: 'product' } : m
      ));
    }
    setTimeout(() => {
      requestAnimationFrame(() => {
        scrollToLoader(20);
      });
    }, 100);
    // requestAnimationFrame(() => scrollToBottom());
  }, []);

  const handleRegularMessage = useCallback((receivedMsg, source) => {
  const hasPendingProduct = pendingProductIdRef.current !== null;

  if (receivedMsg?.shopping_link) {
    const { url, phone: extractedPhone, id } = extractPhoneAndId(receivedMsg.shopping_link, receivedMsg?.is_list);
    link(url);

    const productId = pendingProductIdRef.current;

    console.log("✅ Final data received. Pending product:", productId, "Has pending:", hasPendingProduct);

    if (extractedPhone && id && productId && hasPendingProduct) {
      console.log("🔄 Updating existing product placeholder with final data");

      // Check if data was preloaded
      const isPreloaded = preLoadedData;

      if (!isPreloaded) {
        // Only update if not preloaded
        setProductDataMap(prev => ({
          ...prev,
          [productId]: {
            ...prev[productId],
            phone: extractedPhone,
            productId: id,
            loading: false,
            keyword: receivedMsg?.keyword,
            is_list: receivedMsg?.is_list,
            body: receivedMsg?.body
          }
        }));
      } else {
        // If preloaded, only update the body text
        console.log("📊 Data was preloaded, only updating body");
        setProductDataMap(prev => ({
          ...prev,
          [productId]: {
            ...prev[productId],
            body: receivedMsg?.body
          }
        }));
      }

      pendingProductIdRef.current = null;

      const { beforeEmoji, afterEmoji } = splitMessageByEmoji(receivedMsg?.body || '');
      const beforeText = beforeEmoji || receivedMsg?.body;
      const alreadyShown = shownTextMessagesRef.current.has(beforeText);

      console.log("🔍 Message check:", { beforeEmoji, afterEmoji, alreadyShown, isPreloaded });

      if (afterEmoji) {
        setShowLoading(false);
        console.log("✅ Skipping duplicate message, afterEmoji will render with product");
      } else if (receivedMsg?.body && !isPreloaded) {
        // console.log("yaha aaya")
        setShowLoading(false);
        addMessageIfNotExist(receivedMsg);
        handleScrollAfterMessage(receivedMsg);
      }

      setThreadId(receivedMsg?.thread_id);
      logToBackend("info", "Received message response - updated pending product", { receivedMsg, source });
      setShowTyping(false);
      setCustomMessage("");
      stopProgress();
      setPreLoadedData(false); // Reset the flag

      return;
    } else if (extractedPhone && id && !hasPendingProduct && !preLoadedData) {
      console.log("➕ Adding new product message (no pending)");
      receivedMsg.type = 'product';
      setProductDataMap(prev => ({
        ...prev,
        [receivedMsg.id]: {
          phone: extractedPhone,
          productId: id,
          loading: false,
          keyword: receivedMsg?.keyword,
          is_list: receivedMsg?.is_list,
          body: receivedMsg?.body
        }
      }));
    }
  }

  addMessageIfNotExist(receivedMsg);
  setThreadId(receivedMsg?.thread_id);
  logToBackend("info", "Received message response", { receivedMsg, source });
  setShowTyping(false);
  setCustomMessage("");
  stopProgress();

  handleScrollAfterMessage(receivedMsg);
}, []);

  const handleScrollAfterMessage = (msg) => {
    const isComparisonTable = msg?.body?.match(/①\s*([^\n]+)\n②\s*([^\n]+)\n③\s*([^\n]+)/);

    if (isComparisonTable) {
      setTimeout(() => {
        requestAnimationFrame(() => {
          if (conversationRef.current) {
            const container = conversationRef.current;
            const targetScroll = container.scrollHeight - container.clientHeight - 200;
            container.scrollTop = Math.max(0, targetScroll);
          }
        });
      }, 300);
    } else {
      requestAnimationFrame(() => scrollToBottom());
    }
  };

  const getProgressSteps = (msg) => {
    if (msg?.is_list) {
      return [
        { time: 0, text: msg?.body || "" },
        { time: 5, text: "Searching retailers anonymously — so they can't profile you..." },
        { time: 10, text: "Bigger isn't always cheaper. Calculating unit prices to find the real deals..." },
        { time: 15, text: "Found 2 items where a smaller pack is actually cheaper per unit..." },
        { time: 20, text: "Filtering out third-party sellers with low trust scores..." },
        { time: 25, text: "Sorting by best unit price — cheapest per ounce, per count, per unit..." },
        { time: 33, text: "Checking price history — if they inflated it last week, I'll see it..." },
        { time: 41, text: "Building your one-click 'Add All to Cart' button..." },
        { time: 49, text: "Your cart is ready. One click adds everything — optimized for savings." },
      ];
    } else {
      const useSet1 = Math.random() < 0.5;
      if (useSet1) {
        return [
          { time: 0, text: msg?.body || "" },
          { time: 5, text: "This product's price moves a lot. When you're ready to buy, I'll tell you if it's a good time." },
          { time: 10, text: "Searching Amazon... found 56 results" },
          { time: 15, text: "Searching Walmart... found 39 results" },
          { time: 20, text: "Searching Target... found 13 results" },
          { time: 25, text: "Searching 5+ more stores... found 132 results" },
          { time: 30, text: "Filtering out third-party sellers with low trust scores..." },
          { time: 35, text: "Reading thousands of reviews... I'll warn you if something's off" },
          { time: 40, text: "Scanning Reddit for the unfiltered truth — ask me later" },
          { time: 45, text: "Checking price history... I'll tell you: buy now or wait?" },
          { time: 50, text: "Don't want to wait? Text me anytime on Textroo." },
          { time: 55, text: "Results loading — then ask me anything: 'is this a good deal?' or 'what's wrong with it?'" },
          { time: 60, text: "Building your shortlist — only the best made the cut" }
        ];
      } else {
        return [
          { time: 0, text: msg?.body || "" },
          { time: 5, text: "This product's price varies a lot across retailers. When you're ready to buy, I'll show you where it's cheapest."},
          { time: 10, text: "Searching Amazon... found 41 results"},
          { time: 15, text: "Searching Walmart... found 27 results"},
          { time: 20, text: "Searching Target... found 8 results"},
          { time: 25, text: "Searching 5+ more stores... found 97 results"},
          { time: 30, text: "Filtering out third-party sellers with low trust scores..."},
          { time: 35, text: "Reading thousands of reviews... I'll warn you if something's off"},
          { time: 40, text: "Scanning Reddit for the unfiltered truth — ask me later what people really think"},
          { time: 45, text: "Checking price history... I'll tell you: buy now or wait?"},
          { time: 50, text: "Results loading — then ask me anything: 'is this a good deal?' or 'what's wrong with it?'"},
          { time: 55, text: "Don't want to wait? Text me anytime on Textroo."},
          { time: 60, text: "Building your shortlist — only the best made the cut." }
        ];
      }
    }
  };

  // WebSocket for incoming messages - NOW using unified handler
  useWebSocket({
    url: process.env.REACT_APP_WS_URL,
    phone,
    onEvent: (msg) => {
      console.log("message from broadcast", msg);
      handleIncomingMessage(msg, 'websocket');
    },
  });

  const handlePhoneSubmit = async () => {
    const phoneInput = document.getElementById("userPhoneNumber").value.trim();
    setIsSubmittingPhone(true);

    const messageText = "Hey Roo! Show me what I'm overpaying for 🎯"
    const formData = new URLSearchParams();
    formData.append("From", phoneInput);
    formData.append("Body", messageText);

    fetch(process.env.REACT_APP_TEXTROO_WEBHOOK_URL, {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: formData.toString(),
    })
      .then((response) => {
        setUserPhoneNumber("");
      })
      .catch(() => "")
      .finally(() => {
        setTimeout(() => {
          setUserPhoneNumber("");
        }, 3000);
      });
  };

  const lines = [
    "Thinking...",
  ];

  const PAGE_SIZE = 100;
  const bottomNavHeight = isDesktop ? 0 : 60;
  const inputHeight = 56;
  const chevronBottom = isDesktop
    ? bottomNavHeight + inputHeight + 24
    : bottomNavHeight + inputHeight - 36;

  const extractPhoneAndId = (url, is_list = false) => {
    try {
      const urlObj = new URL(url);
      const parts = urlObj.pathname.split("/");
      const phone = is_list ? parts[3] : parts[2];
      const id = parts[4];
      setPhoneNumber(phone);
      setProductId(id);
      return { phone, id };
    } catch (error) {
      console.error("Error extracting phone/id:", error);
      return { phone: null, id: null };
    }
  };

  useEffect(() => {
    system_warm_up();
  }, []);

  useEffect(() => {
    sendMessage();
  }, [userMsg]);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % lines.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [lines.length]);

  const system_warm_up = async () => {
    const response = await MessageAPIService.system_warm_up();
  };

  const addMessageIfNotExist = (msg) => {
    setMessages((prev) => {
      const exists = prev.some((m) => m?.id === msg?.id);
      if (exists) {
        console.log("Message already exists, skipping:", msg.id);
        return prev;
      }
      console.log("Adding new message:", msg.id);
      return [...prev, msg];
    });
  };

  const getProgress = (secondsElapsed) => {
    if (secondsElapsed < 15) {
      return secondsElapsed * 3;
    }
    if (secondsElapsed < 30) {
      return 45 + (secondsElapsed - 15) * 1.5;
    }
    if (secondsElapsed < 50) {
      return 67 + (secondsElapsed - 30) * 0.7;
    }
    if (secondsElapsed < 70) {
      return 81 + (secondsElapsed - 50) * 0.5;
    }
    if (secondsElapsed < 85) {
      return 91 + (secondsElapsed - 70) * 0.5;
    }
    return Math.min(99, 98.5 + (secondsElapsed - 85) * 0.1);
  };

  const startProgress = (progressSteps) => {
    setProgressActive(true);
    setProgress(0);

    const allSteps = [progressSteps];
    let randomIndex;
    do {
      randomIndex = Math.floor(Math.random() * allSteps.length);
    } while (randomIndex === lastProgressStepIndex && allSteps.length > 1);

    setLastProgressStepIndex(randomIndex);

    const chosenSteps = allSteps[randomIndex];
    setProgressMsg(chosenSteps[0].text);

    let elapsed = 0;
    let elapsedText = 0;

    progressRef.current = setInterval(() => {
      elapsed++;
      const newProgress = getProgress(elapsed);
      setProgress(newProgress);

      if (newProgress >= 99 || elapsed >= 90) {
        clearInterval(progressRef.current);
      }
    }, 1000);

    progressTextRef.current = setInterval(() => {
      elapsedText++;
      const step = [...chosenSteps].reverse().find((s) => elapsedText >= s.time);
      if (step) setProgressMsg(step.text);

      if (elapsedText >= 90) {
        clearInterval(progressTextRef.current);
      }
    }, 1000);
  };

  const stopProgress = () => {
    clearInterval(progressRef.current);
    clearInterval(progressTextRef.current);
    setProgress(100);
    setProgressMsg("");
    setProgressActive(false);
  };

  const scrollToLoader = (offset = 20, duration = 300) => {
    if (!loaderRef.current || !conversationRef.current) return;

    const container = conversationRef.current;
    const loader = loaderRef.current;

    const targetScroll = loader.offsetTop - offset;
    const startScroll = container.scrollTop;
    const change = targetScroll - startScroll;
    const startTime = performance.now();

    const animateScroll = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);

      const easeInOut = progress < 0.5
        ? 2 * progress * progress
        : -1 + (4 - 2 * progress) * progress;

      container.scrollTop = startScroll + change * easeInOut;

      if (progress < 1) {
        requestAnimationFrame(animateScroll);
      }
    };

    requestAnimationFrame(animateScroll);
  };

  const scrollToBottom = () => {
    if (conversationRef.current) {
      conversationRef.current.scrollTop = conversationRef.current.scrollHeight;
    }
  };

  const logToBackend = async (level, message, meta = {}) => {
    try {
      await fetch(`${process.env.REACT_APP_MESSAGE_HANDLER_URL}/api/v1/logs`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ level, message, meta,tester }),
      });
    } catch (err) {
      console.error("Failed to send log:", err);
    }
  };

  const sendMessageFromOption = async (label) => {
    await sendMessageviaButton(label);
  };

  const sendMessage = async () => {
    if (!customMessage.trim()) return;
    setIsSending(true);

    const newMsg = {
      phone,
      source: "user",
      body: customMessage,
      received_at: new Date().toISOString(),
      id: `user-${Date.now()}-${Math.random()}` // Add unique ID for user messages
    };

    setMessages((prev) => [...prev, newMsg]);
    setCustomMessage("");
    setShowTyping(true);
    requestAnimationFrame(scrollToBottom);
    logToBackend("info", "API started", {});

    try {
      const payload = {
        phone: phone,
        body: [{ text: customMessage, media_urls: [] }],
        thread_id: threadId,
        tester:tester,
        platform_access:"Shopperoo_app"
      };

      const code = process.env.REACT_APP_ON_MESSAGE_API_CODE;
      const response = await MessageAPIService.sendMessage(phone, payload, code);

      if (response.status === 200) {
        logToBackend("info", "Received response", { response });

        // Use unified handler for API response
        handleIncomingMessage(response.data, 'api');

        setIsSending(false);
      } else {
        logToBackend("info", "API error", { response });
        setCustomMessage("");
        stopProgress();
        setMessages((prev) => [...prev, {
          id: `error-${Date.now()}`,
          body: "I'm experiencing a technical glitch. I'll reply as soon as I'm back online, hopefully very soon! Please feel free to text me again in a few minutes!"
        }]);
        setShowTyping(false);
        scrollToBottom();
        setIsSending(false);
      }
    } catch (err) {
      logToBackend("info", "api error ", { err });
      setCustomMessage("");
      setMessages((prev) => [...prev, {
        id: `error-${Date.now()}`,
        ...err?.response?.data
      }]);
      scrollToBottom();
      setIsSending(false);
    }
  };

  const sendMessageviaButton = async (value) => {
    setIsSending(true);

    const newMsg = {
      phone,
      source: "user",
      body: value,
      received_at: new Date().toISOString(),
      id: `user-${Date.now()}-${Math.random()}`
    };

    setMessages((prev) => [...prev, newMsg]);
    setCustomMessage("");
    setShowTyping(true);
    requestAnimationFrame(scrollToBottom);
    logToBackend("info", "API started", {});

    try {
      const payload = {
        phone: phone,
        body: [{ text: value, media_urls: [] }],
        thread_id: threadId,
        tester:tester
      };

      const code = process.env.REACT_APP_ON_MESSAGE_API_CODE;
      const response = await MessageAPIService.sendMessage(phone, payload, code);

      if (response.status === 200) {
        logToBackend("info", "Received response", { response });

        // Use unified handler for API response
        handleIncomingMessage(response.data, 'api');

        setIsSending(false);
      } else {
        logToBackend("info", "API error", { response });
        setCustomMessage("");
        stopProgress();
        setMessages((prev) => [...prev, {
          id: `error-${Date.now()}`,
          body: "I'm experiencing a technical glitch. I'll reply as soon as I'm back online, hopefully very soon! Please feel free to text me again in a few minutes!"
        }]);
        setShowTyping(false);
        scrollToBottom();
        setIsSending(false);
      }
    } catch (err) {
      logToBackend("info", "api error ", { err });
      setCustomMessage("");
      setMessages((prev) => [...prev, {
        id: `error-${Date.now()}`,
        ...err?.response?.data
      }]);
      scrollToBottom();
      setIsSending(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !isSending) {
      e.preventDefault();
      sendMessage();
    }
  };

  const handleScroll = useCallback(() => {
    if (!conversationRef.current || loading) return;

    const { scrollTop, scrollHeight, clientHeight } = conversationRef.current;
    setShowScrollDown(scrollTop + clientHeight < scrollHeight - 20);

    if (scrollTop < 50 && currentPage > 1 && !noMoreOldMessages) {
      const prevPage = currentPage - 1;
      if (!loadedPages.has(prevPage)) fetchOlder(prevPage);
    }
  }, [currentPage, loadedPages, noMoreOldMessages, loading]);

  const fetchOlder = async (page) => {
    if (!phone) return;
    setLoading(true);
    try {
      const response = await UserApiService.userConversation(phone, page, PAGE_SIZE, "all");
      const oldMessages = response.messages || [];
      if (!oldMessages.length) setNoMoreOldMessages(true);
      else {
        const oldHeight = conversationRef.current.scrollHeight;
        setMessages((prev) => [...oldMessages, ...prev]);
        setLoadedPages((prev) => new Set(prev).add(page));
        setCurrentPage(page);
        setTimeout(() => {
          if (conversationRef.current) {
            conversationRef.current.scrollTop = conversationRef.current.scrollHeight - oldHeight;
          }
        }, 20);
      }
    } catch (err) {
      Log.e("Error fetching older messages:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const ref = conversationRef.current;
    if (ref) ref.addEventListener("scroll", handleScroll);
    return () => ref?.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);

  // useEffect(() => {
  //   scrollToBottom();
  // }, [messages]);


const renderTextWithLinksAndImages = (text) => {
  if (!text) return null;

  // Extract options JSON if present
  let options = [];
  let hasJson = false;
  const jsonMatch = text.match(/(\{[\s\S]*\})\s*$/);
  if (jsonMatch) {
    try {
      const parsed = JSON.parse(jsonMatch[1]);
      if (parsed?.options) {
        options = parsed.options;
        hasJson = true;
      }

    } catch (e) {
      console.warn("Could not parse options JSON:", e);
    }
    text = text?.replace(jsonMatch[0], "").trim();
  }

  // Remove trailing numbered lists
  if (hasJson) {
    text = text?.replace(/(?:\r?\n\s*\d+\.\s+.*)+\s*$/g, "").trim();
  }

  // Check if this is a comparison table format
  const comparisonMatch = text.match(/①\s*([^\n]+)\n②\s*([^\n]+)\n③\s*([^\n]+)/);

  if (comparisonMatch) {
    return renderComparisonTable(text);
  }

  // Default rendering for non-comparison text
  return renderNormalText(text);
};

const renderComparisonTable = (text) => {
  // console.log('Raw text:', text);

  const lines = text.split('\n');
  // console.log('Split lines:', lines);

  // Extract title (everything before first ①)
  const titleMatch = text.match(/^([^①]+)①/);
  const title = titleMatch ? titleMatch[1].trim() : '';

  // Extract products (lines with ①, ②, ③ but no rating emojis)
  const products = [];
  lines.forEach((line, idx) => {
    const productMatch = line.match(/^[^\S\n]*([①②③])\s*(.+?)$/);
    if (productMatch) {
      const hasRatings = /[🟢🟡🔴]/.test(line);
      if (!hasRatings) {
        products.push({
          number: productMatch[1],
          name: productMatch[2].trim()
        });
      }
    }
  });

  // console.log('Found products:', products);

  // Extract features and their ratings
  const features = [];
  lines.forEach((line, idx) => {
    // console.log(`Checking line ${idx}:`, line);

    // Skip product lines
    if (products.some(p => line.includes(p.name))) {
      return;
    }

    // Check if line contains rating indicators (①②③) AND emojis (🟢🟡🔴)
    const hasNumbers = /[①②③]/.test(line);
    const hasEmojis = /[🟢🟡🔴]/.test(line);

    if (hasNumbers && hasEmojis) {
      // Extract feature name (text before the first ①)
      const featureMatch = line.match(/^([^①②③]+)/);
      if (featureMatch) {
        const featureName = featureMatch[1].trim();

        // Extract ratings in order by finding all emojis
        const ratings = [];
        const emojiMatches = line.match(/[🟢🟡🔴]/gu);

        if (emojiMatches) {
          ratings.push(...emojiMatches);
        }

        // console.log(`Feature "${featureName}" has ratings:`, ratings);

        if (featureName && ratings.length > 0) {
          features.push({
            name: featureName,
            ratings: ratings
          });
        }
      }
    }
  });

  // console.log('Found features:', features);

  // Extract closing message
  const closingMatch = text.match(/How can I help next\?[^]*$/);
  const closingMessage = closingMatch ? closingMatch[0].trim() : '';

  const getRatingColor = (emoji) => {
    if (emoji === '🟢') return '#4caf50';
    if (emoji === '🟡') return '#ff9800';
    if (emoji === '🔴') return '#f44336';
    return '#999';
  };

  const getRatingText = (emoji) => {
    if (emoji === '🟢') return 'Excellent';
    if (emoji === '🟡') return 'Good';
    if (emoji === '🔴') return 'Fair';
    return 'N/A';
  };

  return (
    <div >
      {/* Title */}
      {title && (
        <h3 style={{
          marginBottom: '16px',
          fontSize: '16px',
          fontWeight: '400',
          color: '#333'
        }}>
          {title}
        </h3>
      )}

      {/* Products Header */}
      {products.length > 0 && (
        <div style={{
          marginBottom: '16px',
          padding: '12px',
          backgroundColor: '#f5f5f5',
          borderRadius: '8px'
        }}>
          {products.map((product, idx) => (
            <div key={idx} style={{
              marginBottom: idx < products.length - 1 ? '8px' : '0',
              fontSize: '15px',
              fontWeight: '500'
            }}>
              <span style={{
                display: 'inline-block',
                width: '24px',
                fontWeight: '600'
              }}>
                {product.number}
              </span>
              {product.name}
            </div>
          ))}
        </div>
      )}

      {/* Comparison Table */}
      {features.length > 0 && (
        <div style={{
          overflowX: 'auto',
          marginBottom: '16px',
          border: '1px solid #e0e0e0',
          borderRadius: '8px'
        }}>
          <table style={{
            width: '100%',
            borderCollapse: 'collapse',
            backgroundColor: 'white'
          }}>
            <thead>
              <tr style={{ backgroundColor: '#fafafa' }}>
                <th style={{
                  padding: '12px',
                  textAlign: 'left',
                  borderBottom: '2px solid #e0e0e0',
                  fontWeight: '600',
                  color: '#555',
                  fontSize: '15px'
                }}>
                  Feature
                </th>
                {products.map((product, idx) => (
                  <th key={idx} style={{
                    padding: '12px',
                    textAlign: 'center',
                    borderBottom: '2px solid #e0e0e0',
                    borderLeft: '1px solid #e0e0e0',
                    fontWeight: '600',
                    color: '#555',
                    fontSize: '15px'
                  }}>
                    {product.number}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {features.map((feature, featureIdx) => (
                <tr key={featureIdx} style={{
                  borderBottom: featureIdx < features.length - 1 ? '1px solid #e0e0e0' : 'none'
                }}>
                  <td style={{
                    padding: '12px',
                    fontWeight: '500',
                    fontSize:"15px",
                    color: '#333'
                  }}>
                    {feature.name?.replace(":","")?.replace("-","")}
                  </td>
                  {feature.ratings.map((rating, ratingIdx) => (
                    <td key={ratingIdx} style={{
                      padding: '12px',
                      textAlign: 'center',
                      borderLeft: '1px solid #e0e0e0'
                    }}>
                      <div style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '6px',
                        padding: '4px 12px',
                        borderRadius: '16px',
                        // backgroundColor: `${getRatingColor(rating)}15`,
                        fontSize: '13px',
                        fontWeight: '500',
                        color: getRatingColor(rating)
                      }}>
                        <span style={{ fontSize: '16px' }}>{rating}</span>
                        {/* <span>{getRatingText(rating)}</span> */}
                      </div>
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {features.length > 0 && (
        <div style={{
          marginTop: '16px',
          padding: '16px',
          backgroundColor: '#f9f9f9',
          borderRadius: '8px',
          border: '1px solid #e0e0e0'
        }}>
          <div style={{
            fontSize: '15px',
            fontWeight: '600',
            marginBottom: '12px',
            color: '#333'
          }}>
            Legend
          </div>
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '8px'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span style={{ fontSize: '18px' }}>🟢</span>

              <span style={{
                fontSize: '15px',
                color: '#777'
              }}>
                Excellent / Best-in-class / Has premium feature
              </span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span style={{ fontSize: '18px' }}>🟡</span>

              <span style={{
                fontSize: '15px',
                color: '#777'
              }}>
               Good / Adequate / Standard / Has basic version
              </span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span style={{ fontSize: '18px' }}>🔴</span>

              <span style={{
                fontSize: '15px',
                color: '#777'
              }}>
               Fair / Poor / Below average / Lacks feature
              </span>
            </div>
          </div>
        </div>
      )}

      {/* Closing Message */}
      {closingMessage && (
        <div style={{
          marginTop: '16px',
          fontSize: '16px',

        }}>
          {closingMessage}
        </div>
      )}
    </div>
  );
};

const renderNormalText = (text) => {
  const urlSplitRegex = /(https?:\/\/[^\s)>\]}]+)/;
  const urlTestRegex = /^(https?:\/\/[^\s)>\]}]+)$/i;

  const highlightKeywords = (part) => {
    const keywords = ["Best Value Pick:", "See all picks here"];
    let elements = [part];
    keywords.forEach((keyword) => {
      elements = elements.flatMap((el, i) => {
        if (typeof el !== "string") return el;
        const splitParts = el.split(keyword);
        return splitParts.reduce((acc, curr, idx) => {
          acc.push(curr);
          if (idx < splitParts.length - 1) {
            acc.push(
              <strong key={`${keyword}-${i}-${idx}`} style={{ fontWeight: "bold" }}>
                {keyword}
              </strong>
            );
          }
          return acc;
        }, []);
      });
    });
    return elements;
  };

  const lines = text.split(/\n/);

  return (
    <>
      {lines.map((line, lineIndex) => {
        const parts = line.split(urlSplitRegex);
        return (
          <div key={lineIndex}>
            {parts.map((part, idx) => {
              const trimmed = (part || "").trim();
              if (!trimmed) return null;

              if (urlTestRegex.test(trimmed)) {
                const isStandalone = line.trim() === trimmed;
                if (isStandalone) {
                  return (
                    <img
                      key={idx}
                      src={trimmed}
                      alt="preview"
                      width="100px"
                      style={{ margin: "8px 0", borderRadius: "8px" }}
                    />
                  );
                }
                return (
                  <a
                    key={idx}
                    href={trimmed}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "#1976d2", textDecoration: "underline" }}
                  >
                    {trimmed}
                  </a>
                );
              }

              return <span key={idx}>{highlightKeywords(part)}</span>;
            })}
          </div>
        );
      })}
    </>
  );
};

  // NEW: Function to check if message should show ProductPage
  const shouldShowProductPage = (msg) => {
    // ONLY show ProductPage if:
    // 1. It's explicitly a product type message, OR
    // 2. This specific message has product data in the map
    return msg?.type === 'product' || msg?.type === 'product_loading' || productDataMap[msg?.id];
  };

  const splitMessageByEmoji = (text) => {
  if (!text) return { beforeEmoji: null, afterEmoji: null };

  const emojiSplitters = ["👇", "🎯"];

  // Find which emoji is present (if any)
  const foundEmoji = emojiSplitters.find(emoji => text.includes(emoji));

  // const emojiSplitter = "🎯";
  if (foundEmoji) {
    const parts = text.split(foundEmoji);
    return {
      beforeEmoji: parts[0].trim() + ` ${foundEmoji}`,
      afterEmoji: parts.slice(1).join(foundEmoji).trim() // In case there are multiple of the same emoji
    };
  }

  return { beforeEmoji: text, afterEmoji: null };
};

  return (
    <Box
      sx={{
        flex: "1 1 auto",
        display: "flex",
        flexDirection: "column",
        height: "100%",
        overflowY: "auto",
        position: "relative",
        width: "100%",
      }}
    >
      <Box
        ref={conversationRef}
        sx={{
          flex: "1 1 auto",
          overflowY: "auto",
          px: 2,
          py: 2,
          width: "100%",
          bgcolor: "white",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          marginBottom: "30px"
        }}
      >
        <section style={{ width: "100%", maxWidth: 769, height: "100%" }}>
          {loading && (
            <CircularProgress sx={{ display: "block", margin: "auto", mt: 2 }} />
          )}

          {messages.map((msg, i) => {
            // console.log("message",msg)
            // Check if this is a product loading placeholder
          //   if (msg?.type === 'product_loading') {
          //
          //   }

            // Check if this is a product message - ONLY show ProductPage for these
            // Check if this is a product loading placeholder OR product message


            let option_message_render=false
            if (msg?.type === 'product_loading' || (msg?.type === 'product' && productDataMap[msg?.id])) {
              const productData = productDataMap[msg?.id];
              const isLoading = msg?.type === 'product_loading' || productData?.loading;
              const is_list = productData["is_list"]
              const { beforeEmoji, afterEmoji } = splitMessageByEmoji(productDataMap?.[msg?.id]?.["body"]);
              // console.log("productData",productData)
              return (
                <Box ref={loaderRef} key={`${msg?.id}-${i}`} sx={{ mb: 1, maxWidth: "100%" }}>
                  {/* Show progress bar while loading */}
                  {isLoading && progressActive && (
                    <>
                    <Box sx={{ px: 2, py: 1, mb: 2 }}>
                      <LinearProgress
                        variant="determinate"
                        value={progress}
                        sx={{
                          height: 8,
                          borderRadius: 4,
                          mb: 1,
                          "& .MuiLinearProgress-bar": { backgroundColor: "black" },
                          backgroundColor: "#e0e0e0",
                        }}
                      />
                      <Typography variant="body2" sx={{ opacity: 0.7}}>
                        {progressMsg}
                      </Typography>
                    </Box>

                    {/* textroo sign up box */}
                    {/* <Box
                sx={{
                  backgroundColor: "rgba(0, 0, 0, 0.85)", // Black with 85% opacity
                  boxShadow: "0 -2px 10px rgba(0,0,0,0.3)",
                  padding: "10px",
                  zIndex: 1000,
                  transition: "transform 0.3s ease-in-out",
                  borderRadius:"10px"
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: 2,
                    maxWidth: "1200px",
                    margin: "0 auto",
                  }}
                >

                  {!isSubmittingPhone &&
                  <Typography
                    style={{
                      color: "white",
                      textAlign: "center",
                      fontSize:"14px",
                    }}
                  >
                    Skip the wait! Text Roo for deeper, faster answers + deal alerts.
                  </Typography>
            }


                <Box
                  sx={{
                    display: "flex",
                    gap: 1,
                    width: "100%",
                    maxWidth: "400px",
                    alignItems: "stretch",
                  }}
                >

                {!isSubmittingPhone ?
                <>
                <input
                    type="tel"
                    id="userPhoneNumber"
                    placeholder="Enter your phone number"
                    value={userPhoneNumber}
                    onChange={(e) => setUserPhoneNumber(e.target.value)}
                    disabled={isSubmittingPhone}
                    style={{
                      flex: 1,
                      padding: "12px 16px",
                      fontSize: "14px",
                      border: "1px solid rgba(255, 255, 255, 0.3)",
                      borderRadius: "8px",
                      backgroundColor: "white",
                      color: "black",
                      outline: "none",
                      transition: "all 0.3s",
                    }}
                    onFocus={(e) => {
                      e.target.style.backgroundColor = "white";
                      e.target.style.borderColor = "#ff007f";
                    }}
                    onBlur={(e) => {
                      e.target.style.backgroundColor = "white";
                      e.target.style.borderColor = "rgba(255, 255, 255, 0.3)";
                    }}
                    onKeyDown={(e) => {
                  if (e.key === "Enter" && !isSubmittingPhone) {
                    handlePhoneSubmit();
                  }
                }}
                  />


                  <button
                    style={{
                      padding: "12px 32px",
                      backgroundColor: "#ff007f",
                      color: "white",
                      border: "none",
                      borderRadius: "8px",
                      cursor: "pointer",
                      fontWeight: "bold",
                      fontSize: "14px",
                      transition: "background-color 0.3s, transform 0.2s",
                      whiteSpace: "nowrap",
                    }}
                    onClick={handlePhoneSubmit}
                disabled={isSubmittingPhone}
                    onMouseEnter={(e) => {
                  if (!isSubmittingPhone) {
                    e.target.style.backgroundColor = "#e6006f";
                    e.target.style.transform = "scale(1.02)";
                  }
                }}
                onMouseLeave={(e) => {
                  if (!isSubmittingPhone) {
                    e.target.style.backgroundColor = "#ff007f";
                    e.target.style.transform = "scale(1)";
                  }
                }}
                onMouseDown={(e) => !isSubmittingPhone && (e.target.style.transform = "scale(0.98)")}
                onMouseUp={(e) => !isSubmittingPhone && (e.target.style.transform = "scale(1.02)")}
              >
                    {isSubmittingPhone ? "Sending..." : "Submit"}
                  </button>
                  </>
                  :
                  <Typography style={{color:"white",textAlign:"center",fontSize:"14px"}}>Check your text messages in 60 seconds to talk to your personal shopper</Typography>

              }
                </Box>
                {!isSubmittingPhone &&
                  <Typography style={{color:"white",fontSize:"12px"}}>Free 7-day trial • Cancel anytime • No spam</Typography>
                }
                </Box>
              </Box> */}
              </>
                  )}


                  {/* PART 1: Show the text BEFORE 👇 emoji */}
                  {/* {beforeEmoji && (
                    <Box
                      sx={{
                        display: "inline-block",
                        bgcolor: "transparent",
                        px: 2,
                        py: 1,
                        borderRadius: "12px",
                        whiteSpace: "pre-wrap",
                        wordBreak: "break-word",
                        mb: 2
                      }}
                    >
                      <Typography component="div" sx={{ fontSize: 16 }}>
                        {renderTextWithLinksAndImages(beforeEmoji)}
                      </Typography>
                    </Box>
                  )} */}


                  {/* Show ProductPage when we have product data */}

                  {productData && (
                    <Box
                      sx={{
                        width: "100%",
                        maxWidth: 780,
                        // mt: 1,
                        overflowX: "auto",
                        "@media (max-width:480px)": { maxWidth: "480px!important" },
                        "@media (max-width:430px)": { maxWidth: "390px!important" },
                        "@media (max-width:420px)": { maxWidth: "385px!important" },
                        "@media (max-width:400px)": { maxWidth: "360px!important" },
                        "@media (max-width:385px)": { maxWidth: "340px!important" },
                        "@media (max-width:320px)": { maxWidth: "295px!important" },
                      }}
                    >
                      {/* {console.log("is_list",is_list)} */}
                      {/* {console.log("productData",productData)} */}
                      {is_list?

                      <ShoppingListV2
                      key={`product-${msg?.id}-${productData?.loading}`}
                      loadingSkeleton={productData?.loading || false}
                      phone={trackingPhone || productData?.phone || phoneNumber}
                      productId={productData?.productId || productId}
                      shopperooRender={true}
                      onRenderComplete={() => {
                        // Scroll after ShoppingList is fully rendered
                        setTimeout(() => {
                          requestAnimationFrame(() => {
                            scrollToLoader(20);
                            setShowLoading(false);
                          });
                        }, 100);
                      }}
                      />
                      :
                        <ProductPage
                          key={`product-${msg?.id}`}
                          loadingSkeleton={productData?.loading || false}
                          partialData={productData?.data || []}
                          phone={trackingPhone || productData?.phone || phoneNumber}
                          productId={productData?.productId || productId}
                          keyword={productData?.keyword}
                          shopperooRender = {true}
                          onRenderComplete={(data) => {
                            console.log("onRenderComplete",data)
                        // Scroll after ShoppingList is fully rendered
                        setTimeout(() => {
                          requestAnimationFrame(() => {
                            scrollToLoader(20);
                            setShowLoading(true);
                          });
                        }, 100);
                      }}
                        />
                      }
                    </Box>
                  )}

                   {beforeEmoji ? (
                    <Box
                      sx={{
                        display: "inline-block",
                        bgcolor: "transparent",
                        px: 2,
                        py: 1,
                        borderRadius: "12px",
                        whiteSpace: "pre-wrap",
                        wordBreak: "break-word",
                        // mb: 2,
                        border:"1px solid #bbbbbb"
                      }}
                    >

                      <Typography component="div" sx={{ fontSize: 16 }}>
                        {renderTextWithLinksAndImages(beforeEmoji?.replace(/\[.*?\]/, '').trim())}
                      </Typography>

                    </Box>
                  ):
                  !is_list && showLoading && (productData?.productId) ?  (
                  <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            borderRadius: "12px",
                            border:"1px solid #bbbbbb",
                            py: 2,
                            px: 2,
                          }}
                        >
                          <Box
                            sx={{
                              fontSize: 60,
                              color: "#ff007f",
                              animation: "bounce 1s infinite",
                              "@keyframes bounce": {
                                "0%, 100%": { transform: "translateY(0)" },
                                "50%": { transform: "translateY(-10px)" },
                              },
                            }}
                          >
                            <img src={LogoIcon} style={{ width: "50px", height: "50px" }} />
                          </Box>

                          <Typography
                            variant="h4"
                            align="center"
                            sx={{ maxWidth: 400, fontSize:"12px", color: "#333" }}
                          >
                            Still thinking...
                          </Typography>
                        </Box>
                  ):""
                        }


                  {/* Show the text message below ProductPage if it exists */}
                  {afterEmoji && (
                    <Box sx={{ mt: 2,marginBottom:"32px" }}>
                      {(() => {
                        let text = afterEmoji;
                        let options = [];
                        let hasJson = false;
                        try {
                          option_message_render =true
                          const cleaned = afterEmoji?.replace(/```json|```/g, "").trim();
                          const jsonMatch = cleaned.match(/\{[\s\S]*"options"[\s\S]*\}/);
                          if (jsonMatch) {
                            const parsed = JSON.parse(jsonMatch[0]);
                            if (parsed.options) {
                              options = parsed.options;
                              text = cleaned?.replace(jsonMatch[0], "").trim();
                              hasJson= true;
                            }
                          }
                        } catch (e) {
                          console.error("Failed to parse options JSON:", e);
                        }
                        if (hasJson){
                          text = text?.replace(/(?:^|\s)\d+\.\s+(?!\d)(?!https?:\/\/)[^?]+?(?=(?:\s+\d+\.|$))/g, "").trim();
                        text = text?.replace(/(?:^|\n)[\s]*\d+\.\s+[^\n]+/g, "").trim();
                        }

                        return (
                          <>
                            {text && (
                              <Box
                                sx={{
                                  display: "inline-block",
                                  bgcolor: "transparent",
                                  px: 2,
                                  py: 1,
                                  borderRadius: "12px",
                                  whiteSpace: "pre-wrap",
                                  wordBreak: "break-word",
                                }}
                              >
                                <Typography component="div" sx={{ fontSize: 16 }}>
                                  {renderTextWithLinksAndImages(text)}
                                </Typography>
                              </Box>
                            )}

                            {options.length > 0 && (
                              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 1, ml: "15px" }}>
                                {options.map((opt) => (
                                  <button
                                    key={opt?.id}
                                    onClick={() => sendMessageFromOption(opt.label)}
                                    style={{
                                      // border: "1px solid #ff007f",
                                      border: "1px solid #005cff",

                                      background: "#005cff",
                                      // color: "#ff007f",
                                      color: "white",

                                      borderRadius: "8px",
                                      padding: "6px 12px",
                                      cursor: "pointer",
                                      fontSize: "0.9rem",
                                    }}
                                  >
                                    {opt.label}
                                  </button>
                                ))}
                              </Box>
                            )}
                          </>
                        );
                      })()}
                    </Box>
                  )}
                </Box>
              );
            }

          if (msg?.type !== 'product_loading' && msg?.type !== 'product' && !productDataMap[msg?.id]) {

              // {console.log("msg?.type",msg?.type)}
            // Regular text message
            let text = msg?.body;
            let options = [];
            let hasJson = false;
            try {
              const cleaned = msg?.body?.replace(/```json|```/g, "").trim();
              const jsonMatch = cleaned?.match(/\{[\s\S]*"options"[\s\S]*\}/);
              if (jsonMatch) {
                const parsed = JSON.parse(jsonMatch[0]);
                if (parsed.options) {
                  options = parsed.options;
                  text = cleaned?.replace(jsonMatch[0], "").trim();
                  hasJson=true;
                }
              }
            } catch (e) {
              console.error("Failed to parse options JSON:", e);
            }

            if(hasJson)
            {
              text = text?.replace(/(?:^|\s)\d+\.\s+(?!\d)(?!https?:\/\/)[^?]+?(?=(?:\s+\d+\.|$))/g, "").trim();
              text = text?.replace(/(?:^|\n)[\s]*\d+\.\s+[^\n]+/g, "").trim();
            }

            return (
              <Box
                key={i}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: msg?.source === "user" ? "flex-end" : "flex-start",
                  mb: 4,
                  maxWidth: "100%",
                  // background: options.length > 0 ?"#ecececff" : "transparent",
                  // paddingBottom: options.length > 0 ? "10px": "1px",
                  // borderRadius:"10px"
                }}
              >
                {text && (
                  <Box
                    sx={{
                      display: "inline-block",
                      bgcolor: msg?.source === "user" ? "#ecececff" : "transparent",
                      px: 2,
                      py: 1,
                      borderRadius: "12px",
                      whiteSpace: "pre-wrap",
                      wordBreak: "break-word",
                    }}
                  >
                    <Typography component="div" sx={{ fontSize: 16 }}>
                      {renderTextWithLinksAndImages(text)}
                    </Typography>
                  </Box>
                )}

                {options.length > 0 && (
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 1, ml: "15px" }}>
                    {options.map((opt) => (
                      <button
                        key={opt?.id}
                        onClick={() => sendMessageFromOption(opt.label)}
                        style={{
                          // border: "1px solid #ff007f",
                          border: "1px solid #005cff",


                          background: "#005cff",
                          // color: "#ff007f",
                          color: "white",

                          borderRadius: "8px",
                          padding: "6px 12px",
                          cursor: "pointer",
                          fontSize: "0.9rem",
                        }}
                      >
                        {opt.label}
                      </button>
                    ))}
                  </Box>
                )}
              </Box>
            );

          }
          })}

          {showTyping && (
            <>
              <Box sx={{ display: "flex", justifyContent: "flex-start", marginLeft: "20px" }}>
                <Box
                  sx={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "4px",
                    px: 2,
                    py: 1,
                    borderRadius: "12px",
                    bgcolor: "#f0f0f0",
                  }}
                >
                  <span className="dot"></span>
                  <span className="dot"></span>
                  <span className="dot"></span>
                </Box>
              </Box>
              <Box style={{ marginLeft: "20px", opacity: 0.6 }}>
                {lines[index]}
              </Box>
            </>
          )}

          {/* {progressActive && (
            <Box sx={{ px: 2, py: 1, mb: 2 }}>
              <LinearProgress
                variant="determinate"
                value={progress}
                sx={{
                  height: 8,
                  borderRadius: 4,
                  mb: 1,
                  "& .MuiLinearProgress-bar": { backgroundColor: "#005cff" },
                  backgroundColor: "#e0e0e0",
                }}
              />
              <Typography variant="body2" sx={{ opacity: 0.7, height: "50px" }}>
                {progressMsg}
              </Typography>
            </Box>
          )} */}
        </section>
      </Box>

      <Box
        sx={{
          flex: "0 0 auto",
          display: "flex",
          justifyContent: "center",
          alignItems: messages.length === 0 ? "center" : "flex-end",
          flexDirection: "column",
          height: messages.length === 0 ? "100%" : "auto",
          px: 2,
          pb: messages.length === 0 ? 0 : 1.5,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            border: "2px solid #ff007f",
            borderRadius: "12px",
            px: 1,
            width: "95%",
            maxWidth: 769,
            height: 56,
            bgcolor: "white",
            mx: "auto",
            ...(messages.length === 0 && { mb: "0" }),
          }}
        >
          <TextField
            ref={inputRef}
            placeholder={showTyping ? "" : messages.length > 0 ? "" : "What will you save on today?"}
            variant="standard"
            InputProps={{
              disableUnderline: true,
              sx: { fontSize: "16px", flex: 1, transform: "scale(0.9)", transformOrigin: "left center" },
            }}
            value={customMessage}
            onChange={(e) => setCustomMessage(e.target.value)}
            onKeyDown={handleKeyDown}
            fullWidth
          />
          <IconButton
            sx={{
              bgcolor: "#000",
              color: "#fff",
              borderRadius: "50%",
              width: 32,
              height: 32,
              fontSize: "1.0rem",
              ml: 1,
              "&:hover": { bgcolor: isSending ? "#ccc" : "#111" },
            }}
            disabled={isSending}
            onClick={sendMessage}
          >
            <ArrowUpOutlined sx={{ fontSize: "1.0rem" }} />
          </IconButton>
        </Box>

        {showScrollDown && messages.length > 0 && (
          <IconButton
            onClick={scrollToBottom}
            sx={{
              position: "absolute",
              left: "50%",
              transform: "translateX(-50%)",
              bottom: chevronBottom,
              bgcolor: "white",
              border: "1px solid #ddd",
              boxShadow: 2,
              fontSize: "1.0rem",
              "&:hover": { bgcolor: "#f5f5f5" },
            }}
            disabled={isSending}
          >
            <DownOutlined />
          </IconButton>
        )}
      </Box>
    </Box>
  );
};

export default ChatPage;